import React from 'react'
import NextImage from 'next/image'
import NextLink from 'next/link'
import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { Header } from 'app/KinerjaShared/components/Header'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'
import {
  PERENCANAAN_STEPS_TIM_KINERJA,
  PERENCANAAN_STEPS_PEJABAT_PENILAI_KINERJA,
} from 'app/KinerjaTimPenilaiPSPage/constants/perencanaan'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'

export function TimPenilaiPSTahapanPage() {
  const router = useRouter()
  const { isTimKinerjaPengawasSekolah, isPPKPengawasSekolah } = useRoleContext()
  const { basePath } = useBasePath()

  const steps = React.useMemo(() => {
    if (isTimKinerjaPengawasSekolah) {
      return PERENCANAAN_STEPS_TIM_KINERJA
    }

    if (isPPKPengawasSekolah) {
      return PERENCANAAN_STEPS_PEJABAT_PENILAI_KINERJA
    }

    return []
  }, [isPPKPengawasSekolah, isTimKinerjaPengawasSekolah])

  const handleBack = () => {
    router.replace(basePath)
  }

  return (
    <div className="w-full">
      <div className="p-8 mb-10 bg-white">
        <Header
          title="Tahap Perencanaan Kinerja"
          onBack={handleBack}
          rightNode={
            <NextLink href={`${basePath}/penilai/perencanaan`} passHref>
              <Button as="a" size="lg" className="!w-48 ml-auto space-x-2">
                <span>Lanjut</span>
                <Icon color="inverse">chevron_right</Icon>
              </Button>
            </NextLink>
          }
        />
      </div>

      <div className="mx-auto max-w-7xl">
        <div className="flex items-center justify-between space-x-6">
          {steps.map(({ title, subtitle, icon }, index) => (
            <>
              {index > 0 && (
                <Icon className="!cursor-default">arrow_forward</Icon>
              )}
              <SimpleCard
                key={`tahapan-perencanaan-${index}`}
                data-testid="tahapan-perencanaan-card"
                className="flex flex-col items-center w-full p-6 space-y-8"
              >
                <div className="flex items-center justify-center w-6 h-6 rounded-full bg-icon-default">
                  <Text variant="body-sm" color="inverse">
                    {index + 1}
                  </Text>
                </div>

                <div>
                  <NextImage
                    src={`/illustrations/${icon}.png`}
                    width="84px"
                    height="84px"
                  />
                </div>

                <div className="space-y-2 text-center">
                  <Text variant="heading-md">{title}</Text>
                  <Text color="subdued">{subtitle}</Text>
                </div>
              </SimpleCard>
            </>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TimPenilaiPSTahapanPage
